import React from "../_snowpack/pkg/react.js";
import cs from "../_snowpack/pkg/classnames.js";
import "./Divider.css";
export default function Divider({className, thin}) {
  return /* @__PURE__ */ React.createElement("div", {
    className: cs("divider-component", className, thin && "divider-component--thin")
  });
}
